import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {Favorite} from '@models/favorite';
import {HttpClient} from '@angular/common/http';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {AuthenticationService} from '@services/authentification.service';
import {CommonService} from '@services/common.service';
import {MatDialog} from '@angular/material/dialog';
import {PartnerComponent} from '@components/popup/partner/partner.component';
import {MatSliderChange} from '@angular/material/slider';
import {Router} from '@angular/router';
import {AlertService} from '@services/alert.service';
import * as $ from 'jquery';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-config-rendement-tools',
  templateUrl: './config-rendement-tools.component.html',
  styleUrls: ['./config-rendement-tools.component.scss']
})
export class ConfigRendementToolsComponent implements OnInit {

    user: User = Object.assign({}, EMPTY_USER);
    display_errors = false
    needConfig = true
    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    price = 0;

    constructor(
        private http: HttpClient,
        public cityService: CityService,
        public adService: AdService,
        public alertService: AlertService,
        public deviceService: DeviceDetectorService,
        private router: Router,
        public authenticationService: AuthenticationService,
        public commonService: CommonService,
        public dialog: MatDialog) {
    }

    ngOnInit() {
        document.body.style.overflowY = "hidden";
        if (this.deviceService.isMobile()) {
            setTimeout(function() {
                window.scrollTo({top: 0});
                $("app-ad-widgets").height(document.getElementsByClassName("need-config")[0].clientHeight - 80);
                $("app-ad-widgets").css("overflow", "hidden");
            }, 200);
        }
        this.user = this.authenticationService.currentUser;
        this.favorite = this.adService.fillUSerInfo(this.favorite);
        this.edit(null);
        if (this.favorite.price > 0 && this.favorite.amount_rent > 0) {
            this.price = this.favorite.price
            // Got params from site by $_GET
            this.needConfig = false;
            document.body.style.overflowY = "auto";
            $("app-ad-widgets").css("height", "auto");
            $("app-ad-widgets").css("overflow", "inherit");
        }
    }

    edit(event, fields = '') {
        if (fields === 'price') {
            // Set to null to calculate it
            this.favorite.notary_price = null;
        }
        if (fields === 'works_total') {
            this.favorite.works_square_price = null;
            this.favorite.works_help = -1;
        }
        if (this.authenticationService.currentUser.pro_plan == 'oikos') {
            if (fields === 'price') {
                this.favorite.other_fees = null;
            } else if (fields === 'works_help' || fields === 'works_square_price' || fields === 'works_total') {
                this.favorite.other_fees_work = null;
            }
        }
        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    openPartner(txt) {
        const dialogRef = this.dialog.open(PartnerComponent, {
            width: '1000px',
            data: {txt}
        });
    }

    onInputChange(event: MatSliderChange) {
        console.log('This is emitted as the thumb slides');
        console.log(event.value);
    }

    updateEfficiency(event: MatSliderChange) {
        // Frais de notaire inclus
        let priceTotal = Math.round(this.favorite.amount_rent * 12 / (this.favorite.efficiency_brut / 100));

        priceTotal -= this.favorite.other_fees + this.favorite.other_fees_work + this.favorite.works_total + this.favorite.works_not_deduc + this.favorite.furniture_price + this.favorite.banking_fees + this.favorite.deposit_fees;

        if (this.favorite.estate_sale === 'Neuf') {
            this.favorite.price = Math.round(priceTotal / (1 + this.authenticationService.currentUser.notary_new / 100));
            this.favorite.notary_price = Math.round(this.favorite.price * this.authenticationService.currentUser.notary_new / 100);
        } else {
            this.favorite.price = Math.round(priceTotal / (1 + this.authenticationService.currentUser.notary_old / 100));
            this.favorite.notary_price = Math.round(this.favorite.price * this.authenticationService.currentUser.notary_old / 100);
        }

        this.favorite = this.adService.updateValues(this.favorite);
    }

    updateEfficiencyNet(event: MatSliderChange) {
        // Frais de notaire inclus
        let priceTotal = Math.round(this.favorite.net_rent * 12 / (this.favorite.efficiency_net / 100));

        priceTotal -= this.favorite.other_fees + this.favorite.other_fees_work + this.favorite.works_total + this.favorite.works_not_deduc + this.favorite.furniture_price + this.favorite.banking_fees + this.favorite.deposit_fees;

        if (this.favorite.estate_sale === 'Neuf') {
            this.favorite.price = Math.round(priceTotal / (1 + this.authenticationService.currentUser.notary_new / 100));
            this.favorite.notary_price = Math.round(this.favorite.price * this.authenticationService.currentUser.notary_new / 100);
        } else {
            this.favorite.price = Math.round(priceTotal / (1 + this.authenticationService.currentUser.notary_old / 100));
            this.favorite.notary_price = Math.round(this.favorite.price * this.authenticationService.currentUser.notary_old / 100);
        }

        this.favorite = this.adService.updateValues(this.favorite);
    }

    showResults() {
        this.display_errors = true;
        if (this.favorite.amount_rent > 0 && this.favorite.price > 0) {
            // Need for sliders
            this.price = this.favorite.price
            this.needConfig = false;
            document.body.style.overflowY = "auto";
            $("app-ad-widgets").css("height", "auto");
            $("app-ad-widgets").css("overflow", "inherit");
        }
    }

    saveSimulation() {
        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite.created_at = null;
        this.favorite.ad.fpb = null;
        this.adService.addAnnonce(this.favorite).subscribe(favorite => {
            this.router.navigate(['/app/annonces', favorite.id]);
        }, error => {
            console.log('Error');
            console.log(error);
            this.alertService.error('Une erreur est survenue. Veuillez vérifier les données saisies.');
        });
    }
}
